import { render, staticRenderFns } from "./LecturerComponent.vue?vue&type=template&id=428d4dca&scoped=true&"
import script from "./LecturerComponent.vue?vue&type=script&lang=js&"
export * from "./LecturerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LecturerComponent.vue?vue&type=style&index=0&id=428d4dca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d4dca",
  null
  
)

export default component.exports